import React from "react";

import { withLinks, withMetaData } from "selectors";
import {
  errorCategories,
  getErrorCategoryFromStatus,
  getErrorDescription,
} from "./utils";
import PageFormat from "components/PageFormat";
import { defaultHomePage } from "constants/missions";

export default ({ pageStatus }) => {
  const errorCategory = getErrorCategoryFromStatus(pageStatus);
  const description = getErrorDescription(errorCategory);
  const metadata = withMetaData();
  const links = withLinks();
  const missionHomepage = metadata && metadata.mission_homepage;
  const missionHelpPage = links && links.helpCentre;
  return (
    <>
      <PageFormat>
        <div className="c-hero c-hero--center ln-u-margin-top*4">
          <h2>Something's not right</h2>
          <p className="error-message" style={{ whiteSpace: "break-spaces" }}>
            {description}
          </p>
          {errorCategory === errorCategories.BAD_REQUEST && (
            <p className="error-homeLink">
              Please refresh or go to the{" "}
              <a
                className="ln-c-link ln-c-link--bare ln-c-link--cta"
                href={missionHomepage || defaultHomePage}
              >
                home page
              </a>{" "}
              to try again.
            </p>
          )}
          {errorCategory === errorCategories.NOT_FOUND && (
            <p className="error-homeLink">
              Go to{" "}
              <a
                className="ln-c-link ln-c-link--bare ln-c-link--cta"
                href={missionHomepage || defaultHomePage}
              >
                Homepage
              </a>
              .
            </p>
          )}
          {errorCategory === errorCategories.INTERNAL_SERVER_ERROR && (
            <p className="error-helpLink">
              If you’re continuing to have this problem then please see our{" "}
              <a
                className="ln-c-link ln-c-link--bare ln-c-link--cta"
                href={missionHelpPage || "https://help.sainsburys.co.uk/help/"}
              >
                Help Centre
              </a>
              .
            </p>
          )}
        </div>
      </PageFormat>
    </>
  );
};
